import { useQuery, useMutation, useQueryClient, keepPreviousData } from '@tanstack/react-query';
import apiClient from './apiClient';
import { invalidateMaterialReports } from './useMaterialReports';

export const materialGroupKeys = {
  all: ['materialGroups'],
  list: (filters) => ['materialGroups', filters],
};

/** Busca el catálogo paginado, también usado al seleccionar grupos en pedidos. */
export const useMaterialGroups = (filters = {}, options = {}) => useQuery({
  queryKey: materialGroupKeys.list(filters),
  queryFn: async () => (await apiClient.get('material_groups', { params: filters })).data,
  placeholderData: keepPreviousData,
  staleTime: 5 * 60 * 1000,
  ...options,
});

/** Guarda o desactiva una revisión sin reescribir documentos existentes. */
export const useSaveMaterialGroup = () => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data, remove }) => {
      if (remove) return (await apiClient.delete(`material_groups/${id}`)).data;
      const response = id
        ? await apiClient.put(`material_groups/${id}`, data)
        : await apiClient.post('material_groups', data);
      return response.data;
    },
    onSuccess: () => {
      client.invalidateQueries({ queryKey: materialGroupKeys.all });
      invalidateMaterialReports(client);
    },
  });
};
